import { render } from "./ConversationList.vue?vue&type=template&id=af6f32d6&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"

import "./ConversationList.vue?vue&type=style&index=0&id=af6f32d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6f32d6"]])

export default __exports__